/**
 * Global namespace for most components `show` class.
 */
const showClass = 'show';
export default showClass;
